import { createAction } from 'redux-actions';

export const clearGuestReservations = createAction('CLEAR_GUEST_RESERVATIONS');

export const guestReservationsOnChangePage = createAction(
  'GUEST_RESERVATIONS_ON_CHANGE_PAGE'
);

export const guestReservationsOnChangeOrder = createAction(
  'GUEST_RESERVATIONS_ON_CHANGE_ORDER'
);

export const guestReservationsOnChangeLimit = createAction(
  'GUEST_RESERVATIONS_ON_CHANGE_Limit'
);
